export default "__VITE_ASSET__sYohRXJM__"